
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[communityId]/spaces/[spaceId]",
      function () {
        return require("private-next-pages/[communityId]/spaces/[spaceId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[communityId]/spaces/[spaceId]"])
      });
    }
  